import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dev-code-snippet",
  "use": "icon-dev-code-snippet-usage",
  "viewBox": "0 0 220 220",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 220 220\" id=\"icon-dev-code-snippet\"><rect x=\"39.29\" y=\"105.5\" width=\"144.94\" height=\"9\" transform=\"translate(-23.42 189.48) rotate(-75)\" /><polygon points=\"153.78 168.31 147.42 161.95 199.37 110 147.42 58.05 153.78 51.69 212.1 110 153.78 168.31\" /><polygon points=\"66.22 168.31 7.9 110 66.22 51.69 72.58 58.05 20.63 110 72.58 161.95 66.22 168.31\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol